import { Component, ViewChild } from '@angular/core';
import { AlertController, Content, Events, NavController, NavParams, PopoverController, Tab, Tabs } from 'ionic-angular';
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { TimezoneProvider } from "../../providers/timezone/timezone";
import { PaymentPage } from "../payment/payment";
import { BookingServiceProvider } from "../../providers/booking-service/booking-service";
import { LoyaltyServiceProvider } from "../../providers/loyalty-service/loyalty-service";
import { ServicesPage } from "../services/services";
import { TeamServiceProvider } from "../../providers/team-service/team-service";
import { cloneDeep } from 'lodash';
import { Subscription } from 'rxjs';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';
import { interval } from 'rxjs/observable/interval';
import moment from 'moment';
import { StripeServiceProvider } from '../../providers/stripe-service/stripe-service';
import { PaymentNewCardPage } from '../payment-new-card/payment-new-card';
import { PaymentChangeMethodPopoverPage } from '../payment-change-method-popover/payment-change-method-popover';
import { LobbyPage } from '../lobby/lobby';

@Component({
  selector: 'page-service-summary',
  templateUrl: 'service-summary.html',
})
export class ServiceSummaryPage {
  shop: any;
  barber: any;
  booking: any;
  bookingType: number;
  services: any;
  advancedBooking: any;
  guestUser: any = null;
  byStaff: boolean;
  fromLobby: boolean;
  fromStaffPanel: boolean;
  currencySymbol: string;
  loyalty: any;
  totalAfterRedemptionApplied: any;
  totalRedemptionApplied: any;
  showRedeemButton: boolean = true;
  errors: {};
  loading: boolean = false;
  isFromReschedule: boolean = false;
  headerLoading: boolean = true;
  teamId: any;
  public disablePaymentButton: boolean = false;
  public loadingPaymentMethods: boolean;
  public defaultPaymentMethod: object;
  title: any = 'Your booking with ';

  private bookedDate: Date;
  private nowMoment: Date;
  public flipclock: number = 0;
  public readytime: string = '';
  private subscription: Subscription;
  public shopName: string = "";
  public customer: any;
  public paymentMethods: any;
  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public popoverCtrl: PopoverController,
    public tz: TimezoneProvider,
    private http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private bookingService: BookingServiceProvider,
    public loyaltyProvider: LoyaltyServiceProvider,
    private teamService: TeamServiceProvider,
    public coffeShopService: CoffeShopService,
    public stripeService: StripeServiceProvider,
    private alertCtrl: AlertController
  ) {
    this.shop = navParams.get('shop');
    this.barber = navParams.get('barber');
    this.booking = navParams.get('booking');
    this.services = navParams.get('services');
    this.advancedBooking = navParams.get('advancedBooking');
    this.bookingType = navParams.get('bookingType') ? navParams.get('bookingType') : 1; // 1 = Standard
    this.byStaff = navParams.get('byStaff') ? true : false;
    this.fromLobby = navParams.get('fromLobby') ? true : false;
    
    this.fromStaffPanel = navParams.get('fromStaffPanel') ? true : false;
    this.guestUser = navParams.get('guestUser');
    this.isFromReschedule = navParams.get('isFromReschedule') ? true : false;
    this.totalRedemptionApplied = 0;

    this.coffeShopService.coffeShop = this.shop;
    this.shopName = this.coffeShopService.coffeShop.name;
    if (this.barber) {
      this.title = this.title + this.barber.name;
    }

    if (this.advancedBooking) {
      let date1212 = new Date(this.advancedBooking.date);
      let dates = this.advancedBooking.date.split('/');
      let momendate = dates[1] + '/' + dates[0] + '/' + dates[2]
      const bookedDate = new Date(new Date(new Date(new Date(momendate).setHours(+this.advancedBooking.time.split(':')[0])).setMinutes(+this.advancedBooking.time.split(':')[1])));
      this.bookedDate = cloneDeep(bookedDate);

      this.nowMoment = this.convertTZ(new Date(), this.shop.timezone.timezone);

      const today = this.convertTZ(new Date(), this.shop.timezone.timezone);
      const millisecounds = new Date(bookedDate).getTime() - today.getTime();
      this.flipclock = parseInt(`${Math.ceil(millisecounds / 1000 / 60)}`);
      if (this.flipclock > 0) {
        this.subscription = interval(60000).subscribe(() => {
          if (this.flipclock > 0) {
            this.flipclock = this.flipclock - 1;
          } else {
            this.subscription.unsubscribe();
          }
        });
      }
      this.readytime = 'on ' + moment(bookedDate).format('dddd DD MMMM HH:mm a in');
    }

    if (this.bookingType == 1 && this.booking != null) {
      let selectedDate = moment(this.coffeShopService.selectedDate).format('DD/MM/YYYY');
      let dates = selectedDate.split('/');
      let momendate = dates[1] + '/' + dates[0] + '/' + dates[2]
      const bookedDate = new Date(new Date(new Date(new Date(momendate).setHours(+this.coffeShopService.selectedTime.split(':')[0])).setMinutes(+this.coffeShopService.selectedTime.split(':')[1])));
      this.bookedDate = cloneDeep(bookedDate);

      this.nowMoment = this.convertTZ(new Date(), this.shop.timezone.timezone);

      const today = this.convertTZ(new Date(), this.shop.timezone.timezone);
      const millisecounds = new Date(bookedDate).getTime() - today.getTime();
      this.flipclock = parseInt(`${Math.ceil(millisecounds / 1000 / 60)}`);
      if (this.flipclock > 0) {
        this.subscription = interval(60000).subscribe(() => {
          if (this.flipclock > 0) {
            this.flipclock = this.flipclock - 1;
          } else {
            this.subscription.unsubscribe();
          }
        });
      }
      this.readytime = 'on ' + moment(bookedDate).format('dddd DD MMMM HH:mm a in');

    }

    this.headerLoading = false;
    this.setServiceTotals();
    tz.timezone(this.shop).then((currencySymbol: string) => {
      this.currencySymbol = currencySymbol;
    });
    // setTimeout(() => this.content.scrollToBottom(), 1000);

    events.subscribe('stripe:paymentMethodSaved', (paymentMethod) => {
      this.paymentMethods.data.push(paymentMethod);
      this.defaultPaymentMethod = paymentMethod;
      this.customer.invoice_settings.default_payment_method = paymentMethod.id;
    });
  }

  private convertTZ(date: string | Date, tzString: string): Date {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
  }

  private setPaymentButton(): void {
    if (this.shop.settings.allow_pay_in_app === true) {
      this.disablePaymentButton = this.defaultPaymentMethod ? false : true;
    }
  }

  ionViewCanLeave() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }


  goBack(event) {
    this.navCtrl.pop();
  }

  ionViewDidLoad() {
    this.subscribeToBookingServiceProviderEvents();
    this.getShopLoyaltyPoints();
    this.setPaymentButton();
    this.loadingPaymentMethods = true;
    this.stripeService.getCustomer().then((customer: any) => {
      this.customer = customer;
      this.stripeService.getPaymentMethods().then((methods: any) => {
        this.paymentMethods = methods;
        this.setDefaultSource();
        this.loadingPaymentMethods = false;
        setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 1000);
      });
    },
      err => {
        console.log(err);
        setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 1000);
        this.loadingPaymentMethods = false;
      });
  }

  setDefaultSource() {
    return new Promise((resolve) => {
      for (let paymentMethod of this.paymentMethods.data) {
        if (paymentMethod.id === this.customer.invoice_settings.default_payment_method) {
          this.defaultPaymentMethod = paymentMethod;
          resolve(true);
        }
      }
    });
  }

  addPaymentMethod() {
    if (this.loading) return;
    this.navCtrl.push(PaymentNewCardPage, { referrer: 'paymentPage' })
  }

  ionViewWillEnter() {
    this.removeLoyaltyPoints(true);
  }

  ngOnDestroy() {
    this.bookingService.unsubscribeFromEvents();
  }

  subscribeToBookingServiceProviderEvents() {

    this.bookingService.unsubscribeFromEvents();

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 2));
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:changeServiceTime', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 1));
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:forceAddToQueue', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:joinAvailableSlot', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('validateStandardBookingEndsBeforeTeamOrMemberEndTime:forceAddToQueue', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('validateReplacedBookingFitsAvailableSlot:cancel', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

    this.events.subscribe('validateReplacedBookingFitsAvailableSlot:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

    this.events.subscribe('booking:forceAddToQueue', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('booking:changeServiceTime', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 1));
    });

    this.events.subscribe('booking:backToStart', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 2));
    });

    this.events.subscribe('booking:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 2));
    });

  }

  getBodyForBooking() {
    return this.bookingService.getBodyForBooking(this.booking, this.services, this.shop, this.barber, this.bookingType, this.guestUser, this.advancedBooking, this.byStaff, this.fromLobby);
  }

  checkout() {

    // if (this.loading) return;
    // this.loading = true;

    this.getBodyForBooking().then((body: any) => {
      // Old Flow
      // return this.navCtrl.push(PaymentPage, {
      //   services: this.services,
      //   shop: this.shop,
      //   barber: this.barber,
      //   bookingType: this.bookingType,
      //   advancedBooking: this.advancedBooking,
      //   byStaff: this.byStaff,
      //   fromLobby: this.fromLobby,
      //   fromStaffPanel: this.fromStaffPanel,
      //   booking: body,
      //   guestUser: this.guestUser,
      //   totalAfterRedemptionApplied: this.totalAfterRedemptionApplied,
      //   totalRedemptionApplied: this.totalRedemptionApplied,
      // }).then(()=>{
      //   this.loading = false;
      // });
      this.booking = body;
      this.joinQueuePayment(body);

    }).catch(error => {
      console.log(error);
      this.loading = false;
    });

  }

  makeBooking(booking: any = null) {
    return this.bookingService.makeBooking((booking ? booking : this.booking), this.navCtrl, this.byStaff, this.fromLobby, this.totalRedemptionApplied, this.fromStaffPanel, 'barber');
  }

  byStaffOrFromLobby() {
    if (this.byStaff || this.fromLobby) {
      return true;
    } else {
      return false;
    }
  }

  joinQueue(booking: any = null) {
    if (this.loading) return;
    this.loading = true;

    this.getBodyForBooking().then((body: any) => {
      return this.makeBooking(booking ? booking : body);
    }).then(booking => {
      return this.bookingService.bookingSuccessful(booking, null, 'barber');
    }).then((booking: any) => {
      if (!this.byStaff) {
        this.events.publish('booking:badge+', booking);
      }

      if (booking.staff_member.user_id === parseInt(localStorage.getItem('tuid'))) {
        this.events.publish('myChair:badge', booking);
      }
    }).then(() => {

      // Once the booking has been added we need to take the user back to where they left off
      // we'll do this by looking at which tab they are on and the type of booking that's
      // just been added to the queue
      
      if (this.fromLobby) {
        // console.log('FROM LOBBY');
        // return this.navCtrl.popToRoot();
       return this.navCtrl.popTo(this.navCtrl.getByIndex(0));
      } else if (this.byStaff) {
        let tabBar: Tabs = this.navCtrl.parent;
        if (tabBar) {
          let tab: Tab = tabBar.getSelected();
          // Added from My Chair
          if (tab.index === 2  || tab.index === 3 || tab.index === 4) {
            // console.log('FROM MY CHAIR');
            // Single shop
            if (tab.index === 3 || tab.index === 2 ) {
              // console.log('SINGLE SHOP');
              return this.navCtrl.popToRoot();
            }
            // Multiple shops
            if (tab.index === 4) {
              // console.log('MULTI SHOP');
              return this.navCtrl.popTo(this.navCtrl.getByIndex(1));
            }
          }
          // Added from Staff Panel
          if (tab.index === 5) {
            // console.log('FROM STAFF PANEL');
            return this.navCtrl.popTo(this.navCtrl.getByIndex(2));
          }
        } else {
            this.navCtrl.popTo(this.navCtrl.getByIndex(2));
        }
      } else {
        // console.log('CUSTOMER BOOKING');
        // Customer
        if (this.isFromReschedule) {
          this.navCtrl.pop();
          this.events.publish('booking:cancelled', booking);
        }
        return this.bookingService.gotoMyBookings(this.navCtrl);
      }

    }).then(() => {
      this.loading = false;
    }).catch(error => {
      console.log(error);
      this.loading = false;
    });

  }

  getShopLoyaltyPoints() {
    if (!this.shop.settings.enable_loyalty) return false;

    // @todo check id for Lobby / Staff
    let tuid = localStorage.getItem('tuid');

    return this.loyaltyProvider.getShopLoyaltyPoints(tuid, this.shop.id).then((loyalty: any) => {
      this.loyalty = loyalty;
    })
  }

  removeService(serviceIndex) {
    this.services.services.splice(serviceIndex, 1);
    this.setServiceTotals();
  }

  setServiceTotals() {
    this.bookingService.setServiceTotals(this.services, this.shop, this.byStaffOrFromLobby());
  }

  backToServices() {
    this.navCtrl.pop();
  }

  redeemLoyaltyPoints(loyalty) {

    if (!loyalty.can_redeem) return;
    this.showRedeemButton = false;
    let loyaltyPointsValueInCurrency = parseFloat(loyalty.points_value_in_currency);
    // If loyaltyPointsValueInCurrency >= to the service total cost then the booking is free and we'll use
    // the totalServiceCost in the calculation. Otherwise we'll use the total cost that also includes the service fee
    let totalCost = (loyaltyPointsValueInCurrency >= parseFloat(this.services.totalServiceCost) ? parseFloat(this.services.totalServiceCost) : parseFloat(this.services.totalCost));
    this.totalAfterRedemptionApplied = totalCost - loyaltyPointsValueInCurrency;
    this.totalRedemptionApplied = this.totalAfterRedemptionApplied > 0 ? loyalty.points_value_in_currency : this.services.totalServiceCost;
    this.services.totalCost = parseFloat(this.totalAfterRedemptionApplied) > 0 ? this.totalAfterRedemptionApplied : 0;
  }

  removeLoyaltyPoints(loyalty) {
    this.totalAfterRedemptionApplied = false;
    this.totalRedemptionApplied = 0;
    this.showRedeemButton = true;
    this.setServiceTotals();
  }


  payInShop() {
    if (this.loading) return;
    let alert = this.alertCtrl.create({
      title: "Pay at barbershop",
      subTitle: "Are you sure you want to pay at the barbershop?",
      enableBackdropDismiss: false,
      buttons: [
        {
          text: 'Yes, Pay at barbershop',
          handler: () => {
            this.joinQueue();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        },
      ]
    });
    alert.present();
  }

  paymentIntent() {
    let totalCost = this.totalAfterRedemptionApplied ? this.totalAfterRedemptionApplied : this.services.totalCost;
    return this.stripeService.createPaymentIntent(totalCost, this.customer, this.shop.id);
  }


  joinQueuePayment(bookings: any = null) {

    if (this.loading) return;
    this.loading = true;

    // We pass the booking as it might have been updated in one of the validation events, if it's present it will override this.booking
    this.makeBooking(bookings).then(booking => {
      // The booking was made successfully so we'll now attempt to capture the payment for the booking
      return new Promise(resolve => {
        this.paymentIntent().then(paymentIntent => {
          // The payment was captured successfully
          return resolve([paymentIntent, booking]);
        }).catch(error => {
          // We weren't able to capture the payment
          // this.navCtrl.push(PaymentErrorPage, {
          //   paymentIntentId: error.payment_intent.id,
          //   shopType: 'barber'
          // })
          this.OnCancelPayments();
        });
      });
    }).then(([payment, booking]: any) => {
      // We'll now trigger app events from the booking provider and update the booking with the payment details
      return this.bookingService.bookingSuccessful(booking, payment, 'barber');
    }).then((booking: any) => {
      if (!this.byStaff) {
        this.events.publish('booking:badge+', booking);
      }

      if (booking.staff_member.user_id === parseInt(localStorage.getItem('tuid'))) {
        this.events.publish('myChair:badge', booking);
      }
    }).then(_ => {
      this.bookingService.gotoMyBookings(this.navCtrl);
    }).catch(error => {
      this.loading = false;
    });

  }

  OnCancelPayments() {
    const alert = this.alertCtrl.create({
      subTitle: 'Your Card has been declined due to insufficient fund or expired card we have added you to the queue please pay at the shop.',
      enableBackdropDismiss: false,
      buttons: [
        {
          text: 'OKAY',
          handler: () => {
            this.bookingService.gotoMyBookings(this.navCtrl);
          }
        }]
    });
    alert.present();
  }

  changePaymentMethod() {

    if (this.loading) return;

    let modal = this.popoverCtrl.create(PaymentChangeMethodPopoverPage,
      {
        paymentMethods: this.paymentMethods,
        defaultPaymentMethod: this.defaultPaymentMethod,
      },
      {
        cssClass: 'change-payment-method-popover',
        enableBackdropDismiss: false
      });

    modal.present();

    modal.onDidDismiss((customer) => {
      if (customer) {
        this.customer = customer;
        this.setDefaultSource();
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/service-summary/service-summary.ts